<template>
  <div class="drawer-gift-by-category">
    <div class="content">
      <span ref="headerDrawer" id="headerDrawer"></span>
      <div class="gift-category-search">
        <b-sidebar
          class="filter-sidebar big-modal"
          fullheight="fullheight"
          :fullwidth="fullwidth"
          :overlay="overlay"
          :right="right"
          v-model="open"
        >
          <div class="filter-gifts-sidebar">
            <div class="filter-header">
              <img
                @click="closeMobileFilters"
                class="filter-header-back"
                :src="arrowBack"
              />
              Filtrar e ordenar
              <span v-if="countFiltersSelected" class="counter">
                {{ countFiltersSelected }}
              </span>
            </div>
            <div class="filter-content">
              <div class="filter-content-category-title">Categorias</div>

              <p
                v-for="(category, index) in giftsListCategoriesSaved"
                :key="index"
                class="gift-filters-item"
              >
                <b-field>
                  <b-checkbox
                    v-model="categoriesSelected"
                    :native-value="category"
                  >
                    {{ category.nome }}
                  </b-checkbox>
                </b-field>
              </p>

              <div class="gift-filter-divider"></div>
              <div class="gift-filters-range">
                <div class="gift-filters-range-title">Variação de preço</div>
                <b-field
                  v-for="(range, index) in filterRanges"
                  :key="index"
                  class="gift-filters-range-values"
                >
                  <b-radio v-model="rangeSelected" :native-value="range">
                    {{ range.label }}
                  </b-radio>
                </b-field>
              </div>
              <div class="gift-filter-divider"></div>
              <div class="gift-filters-range">
                <div class="gift-filters-range-title">Ordenar</div>
                <b-field class="gift-filters-range-values">
                  <b-radio v-model="listOrder" native-value="last">
                    Adicionados por último
                  </b-radio>
                </b-field>
                <b-field class="gift-filters-range-values">
                  <b-radio v-model="listOrder" native-value="az">A-Z</b-radio>
                </b-field>
                <b-field class="gift-filters-range-values">
                  <b-radio v-model="listOrder" native-value="small"
                    >Menor valor</b-radio
                  >
                </b-field>
                <b-field class="gift-filters-range-values">
                  <b-radio v-model="listOrder" native-value="big"
                    >Maior valor</b-radio
                  >
                </b-field>
              </div>
            </div>
          </div>
          <div class="filter-gifts-sidebar-footer">
            <div class="wrapper-buttons">
              <button
                class="button is-outlined btn-clean"
                @click="cleanFilters()"
              >
                Limpar filtros
              </button>
              <button class="button is-primary" @click="closeMobileFilters">
                Aplicar filtros
              </button>
            </div>
          </div>
        </b-sidebar>
        <div class="filter-button-wrapper">
          <button
            class="filter-button"
            :class="{
              'filter-button-active': !!countFiltersSelected,
            }"
            @click="openMobileFilters()"
          >
            <img :src="filterImg" /> Filtrar e ordenar
            <span v-if="countFiltersSelected" class="counter">
              {{ countFiltersSelected }}
            </span>
          </button>
        </div>
        <div class="gift-edit-search">
          <div class="gift-list-search-wrapper">
            <img :src="searchIcon" class="icon-search" />
            <input
              v-on:keyup="queringPag"
              type="text"
              v-model="query"
              class="gift-list-search"
              placeholder="buscar produto"
            />
          </div>
        </div>
      </div>
      <div v-if="countFiltersSelected" class="filter-element filter-desktop">
        <div v-if="rangeSelected" class="filter-element-item">
          <div class="filter-text">{{ rangeSelected.label }}</div>
          <img
            :src="closeIcon"
            @click="clearFilterPriceRange"
            class="close-search"
          />
        </div>
        <div
          v-for="(item, index) in categoriesSelected"
          :key="index"
          class="filter-element-item"
        >
          <div class="filter-text">{{ item.nome }}</div>
          <img
            :src="closeIcon"
            @click="removeFilterCategory(index)"
            class="close-search"
          />
        </div>
      </div>
      <div>
        <div
          v-for="(value, name) in giftsFromCatalogGroupByCategories"
          :key="name"
          class="columns is-multiline gifts-cards-container"
        >
          <div class="column is-full">
            <h6 class="gifts-category-title">{{ name }}</h6>
          </div>
          <div
            v-for="gift in value"
            :key="gift.id"
            class="column is-half is-one-third-tablet"
          >
            <GiftCard
              :name="gift.nome"
              :price="gift.valor"
              :image="getUrlImage(gift.img)"
              :isEdit="false"
              @clicked="addGiftFromCatalog(gift.id)"
            />
          </div>
        </div>
      </div>

      <div class="empty-search" v-if="!giftsFromCatalogFiltered.length">
        <div class="empty-search-title">
          Não encontramos nenhum resultado para a sua busca
          <span class="empty-search-highlight">"{{ query }}”.</span>
        </div>
        <div class="empty-search-subtitle">Dicas para melhorar sua busca</div>
        <ul class="empty-search-list">
          <li>Verifique se não houve erro de digitação</li>
          <li>Procure um termo similar ou sinônimo</li>
          <li>Tente procurar termos mais gerais</li>
        </ul>
      </div>
    </div>

    <div class="btn-back-initial">
      <a @click="goTop()"><img :src="arrowUp" />voltar ao início</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'
import {
  sortGifts,
  filterPriceRanges,
  filterGiftsByPriceRange,
  filterGiftsByCategories,
  groupGiftsByCategories,
} from './GiftListUtils'
import GiftCard from './GiftCard.vue'
import LazyImageLoader from '@/plugins/lazy-image-loader'

import uploadImage from '@/assets/img/bycategory.png'
import plusAdd from '@/assets/img/plus-add.svg'
import plusAddCircle from '@/assets/img/plus-add-circle.svg'
import arrowUp from '@/assets/img/arrow-up.svg'
import searchIcon from '@/assets/img/search-icon.svg'
import filterImg from '@/assets/img/filter.svg'
import arrowBack from '@/assets/img/arrow-back.svg'
import closeIcon from '@/assets/img/close-white.svg'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL
const lazyImageLoader = new LazyImageLoader()

export default {
  props: {
    data: {},
  },

  components: {
    GiftCard,
  },

  data() {
    return {
      open: false,
      overlay: false,
      fullheight: true,
      fullwidth: false,
      right: true,

      closeIcon,
      uploadImage,
      plusAdd,
      plusAddCircle,
      arrowUp,
      searchIcon,
      filterImg,
      arrowBack,

      query: null,
      giftsFromCatalog: [],
      categoriesSelected: [],
      rangeSelected: undefined,
      filterRanges: [...filterPriceRanges],
      listOrder: 'az',
      itemsToShow: 50,
    }
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
      giftsListSaved: 'gifts/getGiftsList',
      giftsListCategoriesSaved: 'gifts/getGiftsListCategories',
      giftsFromCatalogSaved: 'gifts/getGiftsFromCatalog',
    }),

    giftsFromCatalogFiltered() {
      const categories = this.categoriesSelected
      const range = this.rangeSelected
      let filtered = this.giftsFromCatalog

      filtered = filterGiftsByCategories(filtered, categories)
      filtered = filterGiftsByPriceRange(filtered, range)
      filtered = sortGifts(filtered, this.listOrder)
      filtered = groupGiftsByCategories(filtered)

      return filtered.slice(0, this.itemsToShow)
    },

    giftsFromCatalogGroupByCategories() {
      return this.giftsFromCatalogFiltered.reduce((result, gift) => {
        const { categoria } = gift
        if (!result[categoria]) {
          result[categoria] = []
        }
        result[categoria].push(gift)
        return result
      }, {})
    },

    countFiltersSelected() {
      return this.categoriesSelected.length + (this.rangeSelected ? 1 : 0)
    },

    notificationAlert: {
      get() {
        return this.$store.state.app.notification
      },
      set(payload) {
        this.$store.dispatch('app/setNotification', payload)
      },
    },
  },

  watch: {
    giftsFromCatalogSaved(newValue) {
      this.giftsFromCatalog = [...newValue]
    },
    giftsFromCatalogFiltered() {
      lazyImageLoader.start()
    },
  },

  created() {
    lazyImageLoader.start()
  },

  mounted() {
    this.giftsFromCatalog = [...this.giftsFromCatalogSaved]

    setTimeout(() => {
      this.itemsToShow = this.giftsFromCatalogSaved.length
    }, 1000)
  },

  methods: {
    ...mapActions({
      fetchGiftsList: 'gifts/fetchGiftsList',
      setGiftsFromCatalog: 'gifts/setGiftsFromCatalog',
    }),

    getUrlImage(image) {
      return `${API_LEGACY_URL}/img/presentes/` + image
    },

    removeFilterCategory(indexToRemove) {
      this.categoriesSelected = this.categoriesSelected.filter(
        (category, index) => index != indexToRemove
      )
    },

    clearFilterPriceRange() {
      this.rangeSelected = undefined
    },

    cleanFilters() {
      this.clearFilterPriceRange()
      this.categoriesSelected = []
    },

    getGiftValue(value) {
      value = parseFloat(value)
      return value.toLocaleString('PT-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      })
    },
    addGiftFromCatalog(gift) {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .addGiftFromCatalog(gift)
        .then((response) => {
          if (!response.data) throw 'Error on add gift in gift list'
          this.fetchGiftsList()
          this.notificationAlert = {
            message: 'Presente adicionado com sucesso.',
            show: true,
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    queringPag() {
      const value = String(this.query).toLowerCase()
      this.giftsFromCatalog = this.giftsFromCatalogSaved.filter((gift) =>
        gift.nome.toLowerCase().includes(value)
      )
    },
    close() {
      this.query = ''
      this.$parent.close('test from child 3')
    },
    openMobileFilters() {
      this.open = true
    },
    closeMobileFilters() {
      this.query = ''
      this.open = false
    },

    goTop() {
      document.getElementById('headerDrawer').scrollIntoView()
    },
  },
}
</script>

<style lang="scss" scoped>
.gifts-cards-container {
  display: flex;
  margin: -8px;

  .gifts-category-title {
    margin: 24px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: $support;
    text-align: left;
  }

  .column {
    flex: none;
    width: 100%;
    padding: 8px;

    @media screen and (min-width: 359px) {
      width: 50%;
    }

    @media screen and (min-width: 500px) {
      width: 33.3333%;
    }

    &.is-full {
      width: 100%;
    }
  }
}

.counter {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: $white;
  border-radius: 100%;
  margin-left: 12px;
  background-color: $primary;
}

#headerDrawer {
  position: absolute;
  margin-top: -100px;
}

.empty-search {
  color: $neutral;
  width: 563px;
  margin: auto;
  margin-top: 48px;
  justify-content: center;

  @media (max-width: $mobile) {
    width: 100%;
  }

  .empty-search-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 32px;

    .empty-search-highlight {
      color: #3dafb0;
    }
  }

  .empty-search-subtitle {
    font-size: 16px;
    font-weight: 700;
  }

  .empty-search-list {
    font-size: 16px;
    font-weight: 400;
    list-style: disc;
  }
}

.filter-gifts-sidebar {
  .filter-header {
    display: flex;
    align-items: center;
    height: 64px;
    border-bottom: 2px solid $neutrallight;
    box-shadow: 0px 2px 4px rgba(93, 117, 141, 0.3);
    padding: 22px;
    font-size: 22px;
    font-weight: 700;
    color: $neutral;
    position: fixed;
    width: 100%;
    background: #fff;
    z-index: 1;

    img {
      padding-right: 22px;
      cursor: pointer;
    }
  }

  .filter-content {
    padding-top: 16px;
    padding-left: 32px;
    padding-right: 32px;

    .filter-content-category-title {
      font-size: 20px;
      font-weight: 700;
      color: $neutral;
      margin-top: 96px;
      margin-bottom: 24px;
    }

    .gift-filters-item {
      font-size: 16px;
      font-weight: 400;
      color: $neutral;
      margin-bottom: 26px;
    }

    .gift-filter-divider {
      border-bottom: 2px solid $neutrallightest;
      width: auto;
      align-self: center;
      height: 2px;
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .gift-filters-range {
      .gift-filters-range-title {
        font-size: 20px;
        font-weight: 700;
        color: $neutral;
        margin-bottom: 24px;
      }

      .gift-filters-range-values {
        font-size: 16px;
        font-weight: 400;
        color: $neutral;
        margin-bottom: 26px;
      }
    }

    .gift-filters-range:nth-last-child(2) {
      margin-bottom: 192px !important;
    }
  }
}

.filter-gifts-sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  margin-bottom: 0px;
  width: 100%;
  background: #fff;
  z-index: 1;
  min-height: 162px;
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  border-top: 2px solid $neutrallight;
  box-shadow: 0px -2px 4px rgba(93, 117, 141, 0.3);

  @media (max-width: $tablet) {
    width: 100vw;
  }

  @media (min-width: $desktop) {
    min-height: 112px;

    .button {
      width: auto !important;
    }
  }

  .wrapper-buttons {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;

    @media screen and (min-width: $desktop) {
      flex-direction: row;
    }
  }

  .button {
    display: block;
    flex: none;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
    height: 56px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 100px;

    &:last-child {
      margin-bottom: 8px;
    }

    @media screen and (min-width: $desktop) {
      max-width: 100%;
      width: auto;
      margin: 0 24px 0 0;

      &:last-child {
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }

  .btn-clean {
    color: #fff;
    background-color: rgba(180, 197, 214, 0.8);
    border-color: rgba(180, 197, 214, 0.8);
  }
}

.gift-category-search {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  @media (max-width: $mobile) {
    display: inline-block;
    width: 100%;

    .filter-button-wrapper {
      width: 100;
      margin-bottom: 24px;

      .filter-button {
        width: 100%;
      }
    }

    .gift-edit-search {
      width: 100%;
    }
  }

  .filter-button {
    color: $neutral;
    background-color: #f9fbfd;
    border: 1px solid #e9eef3;
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
    width: 100%;
    display: flex;
    height: 56px;
    border-radius: 16px;
    align-items: center;
    justify-content: center;
    width: 246.5px;
    margin-right: 20px;
    cursor: pointer;

    &.filter-button-active {
      border: 1px solid $primary;
    }

    img {
      margin-right: 12px;
    }
  }

  .gift-edit-search {
    display: block;
    align-items: center;
    width: 100%;

    .gift-list-search-wrapper {
      width: 100%;
      height: 56px;
      background-color: #fff;
      border-radius: 16px;
      margin-left: 0px;
      margin-right: 0px;
      display: flex;
      align-items: center;
      float: left;

      border: 1.5px solid #dde7f1;
      color: $neutral;

      .icon-search {
        width: 16px;
        height: 16px;
        margin-left: 20px;
        opacity: 0.5;
      }

      .gift-list-search {
        background-color: #fff !important;
        border-radius: 16px;
        width: 100%;
        height: 52px;
        border-color: transparent;

        float: left;
        font-size: 16px;
        color: $neutral;
      }

      .gift-list-search::placeholder {
        color: $neutral;
      }

      .gift-list-search:focus,
      input:focus {
        outline: none;
      }
    }
  }
}

.filter-element {
  margin: 0 0 10px;
  display: flex;
  gap: 8px;
  display: block;

  @media screen and (min-width: $tablet) {
    margin: 24px 0 10px;
  }

  @media (max-width: $mobile) {
    .filter-element-item {
      display: inline-flex !important;
      width: 30% !important;
      margin-bottom: 14px;
      margin-right: 10px;
    }
  }

  .filter-element-item {
    background-color: #3dafb0;
    width: 132px;
    padding: 12px;
    border-radius: 100px;
    height: 32px;
    color: #fff;
    align-items: center;
    display: inline-flex;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 15px;
    margin-right: 10px;

    .filter-text {
      white-space: nowrap;
      width: 85px;
      overflow: hidden;
      padding-bottom: 5px;
      padding-top: 5px;
      text-overflow: ellipsis;
    }

    .close-search {
      padding-left: 12px;
      cursor: pointer;
    }
  }
}

.btn-back-initial {
  position: sticky;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  max-height: 66px;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  background-color: $white;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0px -2px 20px rgba(93, 117, 141, 0.2);

  a {
    display: flex;
    width: 100%;
    height: 66px;
    justify-content: center;
    align-items: center;
    color: #5d758d;
    &:hover {
      color: $neutraldarkest;
    }
  }

  img {
    width: 9px;
    height: 9px;
    margin-right: 8px;
  }
}

::-webkit-scrollbar {
  width: 10px;
}
</style>
